import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import {
  collection,
  addDoc,
  Timestamp,
  doc,
  setDoc,
  deleteDoc,
} from "firebase/firestore";
import logo from "./IMG/logo.png";
import link from "./IMG/link.png"; // Importa o ícone do Link-X
import tabelaMensalidade from "./IMG/2.jpeg"; // Importa a imagem da tabela de mensalidade
import horarioFuncionamento from "./IMG/1.jpeg"; // Importa a imagem do horário de funcionamento
import {
  FaWhatsapp,
  FaInstagram,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaShoppingCart,
  FaGlobe,
  FaClock,
  FaTimes, // Importa o ícone de fechar (X)
} from "react-icons/fa"; // Importa os ícones
import "./App.css";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");

  // Função para abrir o modal com a imagem correspondente
  const openModal = (image) => {
    setModalImage(image);
    setIsModalOpen(true);
  };

  // Função para fechar o modal
  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage("");
  };

  // Função para registrar uma visita no Firestore
  const recordLinkXVisit = async () => {
    try {
      await addDoc(collection(db, "linkXPageVisits"), {
        timestamp: Timestamp.now(),
      });
      console.log("Visita do Link-X registrada");
    } catch (error) {
      console.error("Erro ao registrar visita do Link-X:", error);
    }
  };

  // Função para registrar um usuário ativo
  const registerLinkXActiveUser = async () => {
    const userRef = doc(
      collection(db, "linkXActiveUsers"),
      `user_${Date.now()}`
    );
    await setDoc(userRef, {
      lastActive: Timestamp.now(),
    });

    // Atualiza o campo lastActive a cada 5 segundos
    const heartbeatInterval = setInterval(async () => {
      await setDoc(userRef, { lastActive: Timestamp.now() }, { merge: true });
    }, 5000);

    // Remove o documento ao fechar a janela
    window.addEventListener("beforeunload", async () => {
      clearInterval(heartbeatInterval);
      await deleteDoc(userRef); // Remove o documento quando o usuário sair
    });
  };

  // Função para registrar um clique no botão
  const recordLinkXClick = async (buttonName) => {
    try {
      await addDoc(collection(db, "linkXClickMetrics"), {
        button: buttonName,
        timestamp: Timestamp.now(),
      });
      console.log(`Clique registrado para o botão do Link-X: ${buttonName}`);
    } catch (error) {
      console.error("Erro ao registrar clique no Link-X:", error);
    }
  };

  useEffect(() => {
    recordLinkXVisit(); // Registra uma visita quando a página carrega
    registerLinkXActiveUser(); // Registra o usuário como ativo
  }, []);

  return (
    <div className="app">
      <div className="content">
        {/* Logo e nome da loja */}
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
          <p className="store-name">@AcademiaShapeEmDia</p>
        </div>

        <button
          className="button"
          onClick={() => {
            recordLinkXClick("Whatsapp");
            window.open("https://wa.me/5538991630144");
          }}
        >
          <FaWhatsapp className="icon" /> <span>Whatsapp</span>
        </button>

        <button
          className="button"
          onClick={() => {
            recordLinkXClick("Instagram");
            window.open(
              "https://www.instagram.com/academiashapeemdia?igsh=dno5ZzlsZWt4bnkx"
            );
          }}
        >
          <FaInstagram className="icon" /> <span>Instagram</span>
        </button>

        <button
          className="button"
          onClick={() => {
            recordLinkXClick("Nossa Localização");
            window.open(
              "https://www.google.com/maps/place/Academia+Shape+Em+Dia+-+Av.+São+Judas+Tadeu,+2364+-+São+Judas,+Montes+Claros+-+MG,+39402-558/@-16.7540977,-43.8523098,16z/data=!4m6!3m5!1s0x754abb2aae72f27:0xb1a12a6d1277e6f!8m2!3d-16.7540977!4d-43.8523098!16s%2Fg%2F11h3g47rwb"
            );
          }}
        >
          <FaMapMarkerAlt className="icon" /> <span>Nossa localização</span>
        </button>

        <button
          className="button"
          onClick={() => {
            recordLinkXClick("Horário de Funcionamento");
            openModal(horarioFuncionamento); // Passa a imagem importada
          }}
        >
          <FaClock className="icon" /> <span>Horário de Funcionamento</span>
        </button>

        {/* Botão para Tabela de Mensalidade */}
        <button
          className="button"
          onClick={() => {
            recordLinkXClick("Tabela de Mensalidade");
            openModal(tabelaMensalidade); // Passa a imagem importada
          }}
        >
          <FaCalendarAlt className="icon" /> <span>Tabela de Mensalidade</span>
        </button>

        {/* Botão para Horário de Funcionamento */}
       

        {/* Ícone Link-X no final da página */}
        <div className="link-container">
          <img
            src={link}
            alt="Link-X"
            className="link-icon"
            onClick={() => {
              recordLinkXClick("Link-X");
              window.open("https://codexcorp.com.br", "_blank");
            }}
          />
        </div>
      </div>

      {/* Modal para exibir as imagens */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content">
            <div className="image-container">
              <FaTimes className="close-icon" onClick={closeModal} />
              <img src={modalImage} alt="Modal" className="modal-image" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;